const initialState = {
  loading: false,
  loaded: false,
  errors: {},
  filters: [],
};

const savedFilters = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'SAVED_FILTERS_LIST_REQUEST':
    case 'SAVED_FILTER_CREATE_REQUEST':
    case 'SAVED_FILTER_UPDATE_REQUEST':
    case 'SAVED_FILTER_DELETE_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'SAVED_FILTERS_LIST_SUCCESS':
      return {
        ...state,
        loaded: true,
        loading: false,
        filters: payload,
      };
    case 'UPDATE_SAVED_FILTER_POSITION': {
      const newOrder = [...state.filters];
      newOrder.splice(payload.newPosition, 0, ...newOrder.splice(payload.oldPosition, 1));
      return {
        ...state,
        filters: newOrder,
      };
    }
    case 'SAVED_FILTER_CREATE_SUCCESS':
      return {
        ...state,
        loaded: true,
        loading: false,
        filters: [...state.filters, payload],
      };
    case 'SAVED_FILTER_UPDATE_SUCCESS':
      return {
        ...state,
        loaded: true,
        loading: false,
        filters: state.filters.map((filter) => {
          if (filter.id === payload.id) {
            return payload;
          }
          return filter;
        }),
      };
    case 'SAVED_FILTER_DELETE_SUCCESS':
      return {
        ...state,
        loaded: true,
        loading: false,
        filters: state.filters.filter(filter => filter.id !== payload.savedFilterId),
      };
    case 'SAVED_FILTERS_LIST_FAILURE':
      return {
        ...state,
        loading: false,
        loaded: false,
        errors: payload.errors,
      };
    case 'SAVED_FILTER_CREATE_FAILURE':
    case 'SAVED_FILTER_UPDATE_FAILURE':
    case 'SAVED_FILTER_DELETE_FAILURE':
      return {
        ...state,
        loading: false,
        errors: payload.errors,
      };
    case 'SAVED_FILTER_RESOURCE_CLEAR_VALIDATION':
      return {
        ...state,
        errors: {},
      };
    default:
      return state;
  }
};

export default savedFilters;



// WEBPACK FOOTER //
// ./client/app/reducers/saved_filters.js